import { render, staticRenderFns } from "./BIApprovalTab.vue?vue&type=template&id=722ab0c0&"
import script from "./BIApprovalTab.vue?vue&type=script&lang=js&"
export * from "./BIApprovalTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports